// ShortTimerController.jsx
import React, { useEffect, useState, useCallback } from 'react';
import socket from './socket';

const ShortTimerController = ({
  tableId,
  onCurrentTurnChange,
  player1TimeRefs, // { rail: ref, mobile: ref }
  player2TimeRefs, // { rail: ref, mobile: ref }
}) => {
  const [player1Time, setPlayer1Time] = useState(300);
  const [player2Time, setPlayer2Time] = useState(300);
  const [currentTurn, setCurrentTurn] = useState(null);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, '0');
    const s = String(seconds % 60).padStart(2, '0');
    return `${m}:${s}`;
  };

  // функция, которая пишет текст прямо в DOM
  const updateDomTimes = useCallback(() => {
    const txt1 = formatTime(player1Time);
    const txt2 = formatTime(player2Time);

    if (player1TimeRefs?.rail?.current) {
      player1TimeRefs.rail.current.textContent = txt1;
    }
    if (player1TimeRefs?.mobile?.current) {
      player1TimeRefs.mobile.current.textContent = txt1;
    }

    if (player2TimeRefs?.rail?.current) {
      player2TimeRefs.rail.current.textContent = txt2;
    }
    if (player2TimeRefs?.mobile?.current) {
      player2TimeRefs.mobile.current.textContent = txt2;
    }
  }, [player1Time, player2Time, player1TimeRefs, player2TimeRefs]);

  // когда время меняется — обновляем DOM
  useEffect(() => {
    updateDomTimes();
  }, [updateDomTimes]);

  // 1) таймер стартанул / обновился с сервера
  useEffect(() => {
    const handleShortTimer = ({
      player1_time_left,
      player2_time_left,
      currentTurn,
    }) => {
      setPlayer1Time(player1_time_left ?? 300);
      setPlayer2Time(player2_time_left ?? 300);
      setCurrentTurn(currentTurn);
      if (onCurrentTurnChange) onCurrentTurnChange(currentTurn);
    };

    socket.on('short_timerStarted', handleShortTimer);
    return () => socket.off('short_timerStarted', handleShortTimer);
  }, [onCurrentTurnChange]);

  // 2) синхронизация с сервера
  useEffect(() => {
    const handleShortTimerSync = ({ player1, player2, currentTurn }) => {
      setPlayer1Time(player1 ?? 300);
      setPlayer2Time(player2 ?? 300);
      setCurrentTurn(currentTurn);
      if (onCurrentTurnChange) onCurrentTurnChange(currentTurn);
    };

    socket.on('short_timerSync', handleShortTimerSync);
    return () => socket.off('short_timerSync', handleShortTimerSync);
  }, [onCurrentTurnChange]);

  // 3) локальный тик раз в секунду
  useEffect(() => {
    const intervalId = setInterval(() => {
      setPlayer1Time((prev) =>
        currentTurn === 'player1' ? Math.max(prev - 1, 0) : prev
      );
      setPlayer2Time((prev) =>
        currentTurn === 'player2' ? Math.max(prev - 1, 0) : prev
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, [currentTurn]);

  // компонент ничего не рисует
  return null;
};

export default ShortTimerController;
